(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step6
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Chip" :default Chip]
    ["react-signature-canvas" :default SignatureCanvas]
    ["@mui/icons-material/Backspace" :default BackspaceIcon]
    ["@mui/icons-material/Done" :default DoneIcon]
    ["react" :as react]

    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step1 :as application-form-step1]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step2 :as application-form-step2]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step3 :as application-form-step3]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step4 :as application-form-step4]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step5 :as application-form-step5]
    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-full text-field date-field]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-true check-min-text-length]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))

(defn price-4-division [division]
  (case division
    "St" 1700.00
    1640.00))


(defn format-german-number [num]
  (.toLocaleString (js/Number num) "de-DE" #js {:minimumFractionDigits 2}))

(defn *signature-canvas []
  (let [ref (react/useRef)]
    (rf/dispatch [::application-events/set-signature-ref ref])
    (react/useEffect
      (fn []
        (let [pad (.-current ref)]
          (when-let [data (rf/subscribe [::db/get ::db/selected-application :sig_image_base64])]
            ;; Convert CLJS data to JS structure and load it
            (.fromDataURL pad data)))
        js/undefined)
      #js [])
    [:> SignatureCanvas

     {:ref             ref
      :backgroundColor "#ffffc8"
      :penColor        "blue"
      :canvasProps     {:width     320
                        :height    240
                        :className "sigCanvas"
                        :style     {:border "2px solid #c2c2c2"}}}
     ]))

(def VALIDATOR
  {:dsgvo_confirmed      {}
   :signature_first_name {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Unterschrift Vorname"}
   :signature_last_name  {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Unterschrift Nachname"}
   :signature_place      {:check-fn (check-min-text-length 3) :error-text "Ort mindestens 3 Zeichen" :missing-text "Unterschrift Ort"}
   :signature_date       {}
   :sig_image_base64     {:check-fn (check-min-text-length 3) :error-text "Bitte unterschreiben" :missing-text "Unterschrift"}
   })

(def VALIDATOR_NO_SIGNATURE
  {:dsgvo_confirmed      {}
   :signature_first_name {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Unterschrift Vorname"}
   :signature_last_name  {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Unterschrift Nachname"}
   :signature_place      {:check-fn (check-min-text-length 3) :error-text "Ort mindestens 3 Zeichen" :missing-text "Unterschrift Ort"}
   })

(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)
        form-signable (form-validator VALIDATOR_NO_SIGNATURE !application)
        base-price (price-4-division (:selected_division @!application))
        sum (+ base-price
               (when (:insurance_booked @!application) 20.00)
               (when (:single_room_booked @!application) 200.00)
               )
        ]

    [:> Grid {:container true}

     [grid-full [:> Typography {:variant "h3"} "Anmeldung für " (:shown_first_name @!application) " " (:shown_last_name @!application)]]

     [grid-full [:> Typography {:variant "h5"} "Finanzieller Beitrag"]]


     ;; Steiermark 1700 € pilgerbeitrag



     (if (and (true? (:mhda_member @!application)) (= (:mhda_type @!application) "PE"))
       [:<>
        [grid-full
         [:> Typography {:variant "p"}
          "Wir freuen uns über Deine Spende, Vergelts Gott!"]]
        [grid-small]

        [grid-small
         [:div {:style {:font-weight "" :textAlign "right"}} "Freie Spende (Pilgerpreis wäre EUR " (format-german-number base-price) ")"]]
        [grid-full]
        ]
       [:<>
        [grid-full
         [:> Typography {:variant "p"}
          "Ich verpflichte mich, den vollständigen Pilgerbeitrag in Höhe von "]]

        [grid-small]

        [grid-small
         [:div {:style {:font-weight "" :textAlign "right"}} "Reise  EUR " (format-german-number base-price)]]
        [grid-full]

        (when (:insurance_booked @!application)
          [:<>
           [grid-small]
           [grid-small
            [:div {:style {:font-weight "" :textAlign "right"}} "Versicherung  EUR " (format-german-number 20.00)]]
           [grid-full]])

        (when (:single_room_booked @!application)
          [:<>
           [grid-small]

           [grid-small
            [:div {:style {:font-weight "" :textAlign "right"}} "Einzelzimmer  EUR " (format-german-number 200.00)]]
           [grid-full]])
        [grid-small]
        [grid-small
         [:div {:style {:font-weight "bolder" :textAlign "right"}} "Gesamtsummer  EUR " (format-german-number sum)]]
        ])
     [grid-full
      [:> Typography {:variant "p"}
       " nach dem Erhalt einer schriftlichen Zusage des MHDA umgehend auf das mir namhaft gemachte Konto einzuzahlen. Ein Antritt der Reise ohne vorherige vollständige Bezahlung des Pilgerbeitrags ist nicht möglich. "]]
     [grid-full
      [:> Typography {:variant "p"} "
   Sollte ich die Reise nach Erhalt einer Fixzusage doch nicht antreten können, ist eine Rückerstattung auf Grund der bereits angefallenen Kosten nur in folgendem Ausmaß möglich:
   "]
      [:ul
       [:li "Rücktritt bis 1. Juli: EUR " (format-german-number (* sum 0.75)) " (75%) "]
       [:li "Rücktritt bis 1. September: EUR " (format-german-number (* sum 0.5)) " (50%)"]
       [:li "Rücktritt bis 15. September: EUR " (format-german-number (* sum 0.25)) " (25%)"]
       [:li "Rücktritt nach ab 1. Oktober: EUR " (format-german-number (* sum 0.10)) " (10%)"]
       ]]


     [grid-full [:hr]]
     [grid-full [:br]]
     [grid-full
      [:> Typography {:variant "p"}
       "Mit meiner Unterschrift bestätige ich, dass ich das Anmeldeformular vollständig gelesen und nach bestem Wissen und Gewissen ausgefüllt habe."
       [:br]
       "Ich erkläre mich mit allen darin enthaltenen Bestimmungen einverstanden."
       [:br]
       "Sollte ich die Anmeldung im Namen einer anderen Person "
       "durchgeführt haben, bestätige ich zusätzlich, dass ich über die hierfür erforderliche Vollmacht verfüge."]]

     [grid-small
      [text-field {:label      "Vorname"
                   :value      (:signature_first_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :signature_first_name %])
                   :error      (:error (field-validator :signature_first_name))
                   :helperText (:helperText (field-validator :signature_first_name))
                   }]]
     [grid-small
      [text-field {:label      "Familienname"
                   :value      (:signature_last_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :signature_last_name %])
                   :error      (:error (field-validator :signature_last_name))
                   :helperText (:helperText (field-validator :signature_last_name))}]]
     [grid-full]
     [grid-small
      [text-field {:label      "Ort"
                   :value      (:signature_place @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :signature_place %])
                   :error      (:error (field-validator :signature_place))
                   :helperText (:helperText (field-validator :signature_place))}]]
     [grid-small
      [date-field {:label      "Datum"
                   :disabled   true
                   :value      (or (:signature_date @!application) (first (clojure.string/split (.toISOString (js/Date.)) #"T")))
                   :onChange   #(rf/dispatch [::application-events/store-value :signature_date %])
                   :error      (:error (field-validator :signature_date))
                   :helperText (:helperText (field-validator :signature_date))}]]

     (when (and (:valid form-signable)
                (:valid (form-validator application-form-step1/VALIDATOR !application))
                (:valid (form-validator application-form-step2/VALIDATOR !application))
                (:valid (form-validator application-form-step3/VALIDATOR !application))
                (:valid (form-validator application-form-step4/VALIDATOR !application))
                (:valid (form-validator application-form-step5/VALIDATOR !application))
                )

       [grid-full
        [:div {:style {:text-align "center"}}
         [:h4 "Unterschrift"]
         [:f> *signature-canvas
          ;(:sig_image_base64 @!application)
          ]
         [:br]
         [:span "Bitte im Feld unterschreiben"]
         [:br]
         [:> Button
          {:variant "contained"
           :onClick #(rf/dispatch [::application-events/save-signature])
           :sx      {:m "1em"}}
          "Speichern"]
         [:> Button
          {:startIcon (r/as-element [:> BackspaceIcon])
           :variant   "contained"
           :onClick   #(rf/dispatch [::application-events/clear-signature])
           :sx        {:m "1em"}}
          "Feld leeren"]
         ]])

     [grid-full [:> Typography {:variant "p"} ""]]

     [grid-full
      ;[:pre (pr-str form-valid)]
      (if-not (and (:valid form-valid)
                   (:valid (form-validator application-form-step1/VALIDATOR !application))
                   (:valid (form-validator application-form-step2/VALIDATOR !application))
                   (:valid (form-validator application-form-step3/VALIDATOR !application))
                   (:valid (form-validator application-form-step4/VALIDATOR !application))
                   (:valid (form-validator application-form-step5/VALIDATOR !application))
                   )
        (into
          [:<> "Es fehlen noch folgende Eingaben: " [:br]
           (when-not (:valid (form-validator application-form-step1/VALIDATOR !application))
             [:> Chip {:label (str "Informationen nicht bestätigt") :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
           (when-not (:valid (form-validator application-form-step2/VALIDATOR !application))
             [:> Chip {:label (str "Persönliche Daten") :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
           (when-not (:valid (form-validator application-form-step3/VALIDATOR !application))
             [:> Chip {:label (str "Reisedetails / Notfallkontakt") :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
           (when-not (:valid (form-validator application-form-step4/VALIDATOR !application))
             [:> Chip {:label (str "Kurzfragebogen") :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
           (when-not (:valid (form-validator application-form-step5/VALIDATOR !application))
             [:> Chip {:label (str "Bildrechte") :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
           ]

          (for [missing (:formMissingText form-valid)]
            [:> Chip {:label (str missing) :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
          )

        [grid-full [:> Typography {:variant "h3" :sx {:color "darkgreen" :text-align "center" :border "2px solid darkgreen" :padding "6px"}}
                    "Diese Anmeldung ist vollständig, vielen Dank" [:br] [:br]
                    [:> Button
                     {:component "a" :href "/dashboard"
                      :variant   "outlined"}
                     [:> DoneIcon] "Zurück zur Übersicht"]
                    ]]
        )
      ]


     [grid-full [:> Typography {:variant "h3"} "Informationen über Datenschutz"]]
     [grid-full
      [:> Typography {:variant "p"}
       "Damit die Wallfahrt/Reise durch den MHDA durchgeführt werden kann, müssen einige personenbezogene Daten verarbeitet werden. "
       "Der MHDA sichert die sichere und vertrauliche Verarbeitung Ihrer Daten zu. Informationen über die Verarbeitung von personenbezogenen "
       "Daten durch den MHDA finden Sie in unserer Datenschutzerklärung unter "
       [:a {:href "https://www.malteser.at/Datenschutz" :target "_blank"} "www.malteser.at/Datenschutz"]
       ". "
       "Gerne stellen wir diese auf Anfrage auch per E-Mail oder per Post zur Verfügung."]]
     ]))